import styled from 'styled-components';
import { useEffect } from 'react';
import { useThrottledResizeObserver } from 'utils/hooks';

function Resizer({ onResize, children, ...restProps }) {
    const { ref, width, height } = useThrottledResizeObserver(250);

    useEffect(() => {
        if (width && height) onResize(width, height);
    }, [onResize, width, height]);

    return (
        <div ref={ref} {...restProps}>
            {children}
        </div>
    );
}

const Chart = styled(Resizer)`
    max-width: 100%;
    height: ${({ height }) => `${height}px`};
    grid-area: chart;
`;

export default Chart;
